import React from 'react'

const CurriculumTab = () => {
    return (
        <li>

            <ul className="course-curriculum" uk-accordion="multiple: true">

                <li className="uk-open">
                    <a className="uk-accordion-title" href="#"> Html Introduction </a>
                    <div className="uk-accordion-content">

                        {/* <!-- course-video-list --> */}
                        <ul className="course-curriculum-list">
                            <li> What is HTML <span> 23 min </span></li>
                            <li> What is a Web page? <span> 23 min </span> </li>
                            <li> Your First Web Page <a href="#trailer-modal" uk-toggle=""> Preview
                                    </a> <span> 23 min </span>
                            </li>
                            <li> Brain Streak <span> 23 min </span> </li>
                        </ul>

                    </div>
                </li>

                <li>
                    <a className="uk-accordion-title" href="#"> Your First webpage   </a>
                    <div className="uk-accordion-content">

                        {/* <!-- course-video-list --> */}
                        <ul className="course-curriculum-list">
                            <li> Headings <span> 23 min </span></li>
                            <li> Paragraphs <span> 23 min </span> </li>
                            <li> Emphasis and Strong Tag <a href="#trailer-modal" uk-toggle="">
                                Preview
                                    </a> <span> 23 min
                                    </span>
                            </li>
                            <li> Brain Streak <span> 23 min </span> </li>
                            <li> Live Preview Feature <span> 23 min </span> </li>
                        </ul>

                    </div>
                </li>

                <li>
                    <a className="uk-accordion-title" href="#"> Some Special Tags  </a>
                    <div className="uk-accordion-content">

                        {/* <!-- course-video-list --> */}
                        <ul className="course-curriculum-list">
                            <li> The paragraph tag <span> 23 min </span> </li>
                            <li> The break tag <a href="#trailer-modal" uk-toggle=""> Preview </a>
                                <span> 23 min </span> </li>
                            <li> Headings in HTML <span> 23 min </span> </li>
                            <li> Bold, Italics Underline <span> 23 min </span>
                            </li>
                        </ul>

                    </div>
                </li>

                <li>
                    <a className="uk-accordion-title" href="#"> HTML Advanced level   </a>
                    <div className="uk-accordion-content">

                        {/* <!-- course-video-list --> */}
                        <ul className="course-curriculum-list">
                            <li> Something to Ponder<span> 23 min </span> </li>
                            <li> Tables <span> 23 min </span> </li>
                            <li> HTML Entities <a href="#trailer-modal" uk-toggle=""> Preview
                                    </a><span> 23 min </span> </li>
                            <li> HTML Iframes <span> 23 min </span> </li>
                            <li> Some important things <span> 23 min </span> </li>
                        </ul>

                    </div>
                </li>

            </ul>

        </li>

    )
}

export default CurriculumTab
